import React, { useContext } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { AuthContext } from "../contexts/AuthContext";

const PublicRoute = () => {
  const { token } = useContext(AuthContext);
  return !token ? <Outlet /> : <Navigate to="/dashboard" />;
};

export default PublicRoute;
